import PropTypes from "prop-types";
import React from "react";
import _isEqual from "lodash/isEqual";
import { connect } from "react-redux";
import { Redirect, Route, Switch } from "react-router-dom";
import BrowserDetection from "react-browser-detection";
import { isMobile } from "react-device-detect";
import BrowserSupportError from "../components/BrowserSupportError";
import MobileSupportError from "../components/MobileSupportError";
import AcceptInvitationContainer from "./AcceptInvitationContainer";
import AppHeaderContainer from "./AppHeaderContainer";
import DashboardContainer from "./DashboardContainer";
import ForgotPasswordContainer from "./ForgotPasswordContainer";
import LoginContainer from "./LoginContainer";
import LoginWithTokenContainer from "./LoginWithTokenContainer";
import MyAccountContainer from "./MyAccountContainer";
import NotificationContainer from "./NotificationContainer";
import ResetPasswordContainer from "./ResetPasswordContainer";
import ResultsContainer from "./ResultsContainer";
import WevoConfigurationContainer from "./WevoConfigurationContainer";
import requiresAuthentication from "../utils/requiresAuthentication";

import "../styles/base.css";
import * as styles from "../styles/App.css";

const allowedMobilePaths = ["/accelerate", "/dashboard", "my-account"];

class App extends React.PureComponent {
    constructor(props) {
        super(props);
        this.renderApp = this.renderApp.bind(this);
    }

    static propTypes = {
        location: PropTypes.object.isRequired
    };

    renderApp() {
        const session = this.props.session;
        return (
            <div>
                <header className={styles.header}>
                    <AppHeaderContainer />
                </header>

                <section className={styles.notifications}>
                    <NotificationContainer />
                </section>

                <div className={styles.body}>
                    <Switch>
                        <Route
                            exact
                            path="/"
                            render={() => {
                                return session.authRequired ? (
                                    <Redirect to="/login" />
                                ) : (
                                    <Redirect
                                        to={`/team/${session.teamId}/dashboard`}
                                    />
                                );
                            }}
                        />
                        {/* facilitates token-based login, redirects to dashboard */}
                        <Route
                            exact
                            path="/accelerate"
                            component={LoginWithTokenContainer}
                        />
                        <Route exact path="/login" component={LoginContainer} />
                        {/* the LoginContainer redirects to the hello login page */}
                        <Route
                            exact
                            path="/new-user/:tokenId"
                            component={AcceptInvitationContainer}
                        />
                        <Route
                            exact
                            path="/forgot-password"
                            component={ForgotPasswordContainer}
                        />
                        <Route
                            exact
                            path="/reset-password/:tokenId"
                            component={ResetPasswordContainer}
                        />
                        <Route
                            exact
                            path="/my-account"
                            component={requiresAuthentication(
                                MyAccountContainer
                            )}
                        />
                        <Route
                            exact
                            path="/team/:teamId/dashboard"
                            component={requiresAuthentication(
                                DashboardContainer
                            )}
                        />
                        <Route
                            path="/team/:teamId/results/:wevoId"
                            component={requiresAuthentication(ResultsContainer)}
                        />
                        <Route
                            path="/shared/:shareLinkId"
                            component={ResultsContainer}
                        />
                        <Route
                            exact
                            path="/team/:teamId/createTest"
                            component={requiresAuthentication(
                                WevoConfigurationContainer
                            )}
                        />
                        <Route
                            exact
                            path="/team/:teamId/edit/:wevoId"
                            component={requiresAuthentication(
                                WevoConfigurationContainer
                            )}
                        />
                        <Route
                            exact
                            path="/team/:teamId/details/:wevoId"
                            component={requiresAuthentication(
                                WevoConfigurationContainer
                            )}
                        />
                    </Switch>
                </div>
            </div>
        );
    }

    browserHandler() {
        return {
            ie: BrowserSupportError,
            edge: BrowserSupportError,
            default: this.renderApp
        };
    }

    render() {
        if (
            isMobile &&
            window.location.pathname !== "/" &&
            !allowedMobilePaths.some(path =>
                window.location.pathname.includes(path)
            )
        ) {
            return <MobileSupportError />;
        }

        return <BrowserDetection>{this.browserHandler()}</BrowserDetection>;
    }
}

function mapStateToProps(state) {
    return {
        session: state.session,
        user: state.entities.users[state.session.userId]
    };
}

/**
 * The main component for the Aurora app.
 *
 * IMPORTANT: You must supply this component with a location property suitable for use with react-router. You can pass
 * the property directly, or arrange for react-router to pass it by wrapping this component with a <Route> or using the
 * withRouter function. If you do not do one of these, the component will not re-render when the location changes. See
 * the following links for details:
 *
 * {@link https://github.com/ReactTraining/react-router/blob/master/packages/react-router/docs/guides/blocked-updates.md}
 * {@link https://github.com/ReactTraining/react-router/blob/master/packages/react-router/docs/guides/redux.md#blocked-updates}
 */
export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/App.js